import { render, staticRenderFns } from "./DetailData.vue?vue&type=template&id=35d0d64e&scoped=true"
import script from "./DetailData.vue?vue&type=script&lang=js"
export * from "./DetailData.vue?vue&type=script&lang=js"
import style0 from "./DetailData.vue?vue&type=style&index=0&id=35d0d64e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d0d64e",
  null
  
)

export default component.exports